import { notifications } from './notifications';

export const notify = {
  namespaced: true,
  modules: {
    notifications
  }
};
